@if (derivedSearchResult$ | async) {
  <ds-listable-object-component-loader
    [viewMode]="ViewModes.ListElement"
    [object]="derivedSearchResult$ | async" [linkType]="LinkTypes.None"
    [context]="badgeContext"
    [showLabel]="showLabel"
    [showMetrics]="false"
    [showThumbnails]="showThumbnails"
    [showWorkflowStatistics]="showWorkflowStatistics"></ds-listable-object-component-loader>
  <div class="row">
    <div [ngClass]="showThumbnails ? 'offset-3 offset-xl-2 col-9 col-md-10 ps-3' : 'ms-3'">
      <ds-workspaceitem-actions [object]="dso" (processCompleted)="reloadedObject.emit($event.reloadedObject)"></ds-workspaceitem-actions>
    </div>
  </div>
}
@if ((derivedSearchResult$ | async) === undefined) {
  <ds-loading
  [showMessage]="false"></ds-loading>
}
